import { type Hitbox, HitboxType } from "@common/utils/hitbox";

/**
 * whether a hitbox's bounds (each part's, for a group) reach into the box `minX`..`maxX` by `minY`..`maxY` (game
 * units): read off the hitbox's own numbers, nothing made (0.98.8: a line inside the box can't cross a hitbox whose
 * bounds stay out of it, so the line tests a roof's rays and the bullets make skip those)
 */
export function boundsReach(hitbox: Hitbox, minX: number, minY: number, maxX: number, maxY: number): boolean {
    switch (hitbox.type) {
        case HitboxType.Rect:
            return hitbox.max.x >= minX && hitbox.min.x <= maxX && hitbox.max.y >= minY && hitbox.min.y <= maxY;
        case HitboxType.Circle: {
            const { x, y } = hitbox.position, r = hitbox.radius;
            return x + r >= minX && x - r <= maxX && y + r >= minY && y - r <= maxY;
        }
        case HitboxType.Group:
            for (const part of hitbox.hitboxes) if (boundsReach(part, minX, minY, maxX, maxY)) return true;
            return false;
        case HitboxType.Polygon: {
            let x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
            for (const point of hitbox.points) {
                if (point.x < x0) x0 = point.x;
                if (point.y < y0) y0 = point.y;
                if (point.x > x1) x1 = point.x;
                if (point.y > y1) y1 = point.y;
            }
            return x1 >= minX && x0 <= maxX && y1 >= minY && y0 <= maxY;
        }
        default:
            return true;
    }
}
